import { TeamRole } from 'containers/app/app.model';
import { getRoleName } from 'containers/manage-team/utils';

// Teams can share a name, so the label is what tells them apart. It trails the
// role on one line; with no label the role shows alone, without a separator.
export const getTeamSubtitle = (role: TeamRole | string, label?: string): string => {
  const roleName = getRoleName(role as TeamRole);
  const trimmedLabel = label?.trim();
  return trimmedLabel ? `${roleName} · ${trimmedLabel}` : roleName;
};
